// Composable that calls a callback when the page becomes visible or focused again.
// Handles both visibilitychange (tab switching) and focus (window switching).

import { onMounted, onUnmounted } from 'vue'

export function usePageFocus(callback) {
  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') callback()
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', onVisibilityChange)
    window.addEventListener('focus', callback)
  })

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', onVisibilityChange)
    window.removeEventListener('focus', callback)
  })
}
